import React, { useEffect, useState } from "react";
import {
  Modal,
  Tabs,
  Table,
  Tag,
  Descriptions,
  Spin,
  Badge,
  Button,
  message,
  Space,
  Upload,
  Form,
  Input,
  Select,
} from "antd";
import {
  UserOutlined,
  EyeOutlined,
  CalendarOutlined,
  DollarOutlined,
  PlusOutlined,
  FileOutlined,
  CloseOutlined,
  EditOutlined,
  DeleteOutlined,
  FolderOpenOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import axiosInstance from "../../utils/axios.config";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Card, Statistic } from "antd";
import AddSessionModal from "../sessions/AddSessionModal";
import AddCaseModal from "../case/AddCaseModal";
import EditCaseModal from "../case/EditCaseModal";
import {
  casesService,
  paymentsService,
  documentsService,
} from "../../services/api.service";
import Swal from "sweetalert2";
import { sessionsService } from "../../services/api.service";
import ViewSessionModel from "../sessions/ViewSessionModel";
import EditSessionModal from "../sessions/EditSessionModal";
import PaymentReceipt from "../payments/PaymentReceipt";
import PaymentDetailsModal from "../payments/PaymentDetails";
import AddPaymentModal from "../payments/addPayment";
import EditPaymentModal from "../payments/EditPaymentModal";
import DocumentsList from "../DocumentsList";
import { InboxOutlined, CloudUploadOutlined } from "@ant-design/icons";
import logger from "../../utils/logger";

const { TabPane } = Tabs;

const ViewClientModal = ({ visible, client, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [clientCases, setClientCases] = useState([]);
  const [clientSessions, setClientSessions] = useState([]);
  const [clientPayments, setClientPayments] = useState([]);
  const [clientDocuments, setClientDocuments] = useState([]);
  const [activeTab, setActiveTab] = useState("1"); // Default to first tab
  const [showAddSessionModal, setShowAddSessionModal] = useState(false);
  const [showAddCaseModal, setShowAddCaseModal] = useState(false);
  const [editCaseModalVisible, setEditCaseModalVisible] = useState(false);
  const [caseToEdit, setCaseToEdit] = useState(null);
  const [showUploadArea, setShowUploadArea] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [showFileDetailsModal, setShowFileDetailsModal] = useState(false);
  const [documentDetails, setDocumentDetails] = useState({
    title: "",
    document_type: "",
    notes: "",
  });
  const navigate = useNavigate();
  const [editPaymentModalVisible, setEditPaymentModalVisible] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [editSessionModalVisible, setEditSessionModalVisible] = useState(false);
  const [viewSessionModalVisible, setViewSessionModalVisible] = useState(false);
  const [currentSessionDetails, setCurrentSessionDetails] = useState(null);
  const [isEditSessionModalVisible, setIsEditSessionModalVisible] =
    useState(false);
  const [currentSession, setCurrentSession] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [showReceiptDialog, setShowReceiptDialog] = useState(false);
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [viewPaymentDetails, setViewPaymentDetails] = useState(false);
  const [editPaymentDetails, setEditPaymentDetails] = useState(false);
  const [currentPayment, setCurrentPayment] = useState(null);
  const [paymentToEdit, setPaymentToEdit] = useState(null);

  useEffect(() => {
    if (visible && client?.id) {
      // جلب البيانات الأساسية
      fetchClientCases(client.id);

      // إضافة هذا السطر لجلب المدفوعات مباشرة عند فتح التفاصيل
      fetchClientPayments(client.id);

      // جلب جلسات العميل
      fetchClientSessions(client.id);

      // جلب مستندات العميل
      fetchClientDocuments(client.id);
    }
  }, [visible, client]);

  const fetchClientCases = async (clientId) => {
    try {
      setLoading(true);
      // استخدام مسار API مناسب للحصول على قضايا العميل
      const response = await axiosInstance.get(`/cases/client/${clientId}`);

      if (response.data && response.data.data) {
        setClientCases(response.data.data);
      } else {
        setClientCases([]);
        logger.debug("لا توجد قضايا لهذا العميل");
      }
    } catch (error) {
      logger.error("Error fetching client cases:", error);
      message.error("فشل في جلب قضايا العميل");
      setClientCases([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchClientSessions = async (clientId) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/sessions/client/${clientId}`);

      if (response.data && Array.isArray(response.data.data)) {
        setClientSessions(response.data.data);
      } else {
        setClientSessions([]);
        logger.debug("لا توجد جلسات لهذا العميل");
      }
    } catch (error) {
      logger.error("Error fetching client sessions:", error);
      setClientSessions([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchClientPayments = async (clientId) => {
    try {
      setLoading(true);
      // استخدام مسار API مناسب للحصول على مدفوعات العميل
      const response = await axiosInstance.get(`/payments/client/${clientId}`);

      if (response.data && response.data) {
        setClientPayments(response.data);
      } else {
        setClientPayments([]);
        logger.debug("لا توجد مدفوعات لهذا العميل");
      }
    } catch (error) {
      // logger.error('Error fetching client payments:', error);
      // message.error('فشل في جلب مدفوعات العميل');
      setClientPayments([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchClientDocuments = async (clientId) => {
    try {
      setLoading(true);
      const response = await documentsService.getClientDocuments(clientId);

      if (response && response.data) {
        setClientDocuments(response.data);
        logger.debug("Client documents loaded:", response.data);
      } else if (response && response.success) {
        setClientDocuments(response.data || []);
      } else {
        setClientDocuments([]);
        logger.debug("لا توجد مستندات لهذا العميل");
      }
    } catch (error) {
      logger.error("Error fetching client documents:", error);
      message.error("فشل في جلب مستندات العميل");
      setClientDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (key) => {
    setActiveTab(key);

    if (client?.id) {
      // جلب القضايا عند الانتقال إلى تبويب القضايا
      if (key === "2") {
        fetchClientCases(client.id);
      }

      // جلب الجلسات عند الانتقال إلى تبويب الجلسات
      if (key === "3") {
        fetchClientSessions(client.id);
      }

      // جلب المدفوعات عند الانتقال إلى تبويب المدفوعات
      if (key === "4") {
        fetchClientPayments(client.id);
      }

      // جلب المستندات عند الانتقال إلى تبويب المستندات
      if (key === "5") {
        fetchClientDocuments(client.id);
      }
    }
  };
  const handleAddSessionClick = () => {
    setShowAddSessionModal(true);
  };
  const handleAddCase = () => {
    setShowAddCaseModal(true);
  };

  // دالة معالجة النقر على زر التعديل
  const handleEditSession = (sessionData, e) => {
    e.stopPropagation();
    setCurrentSession({ ...sessionData }); // نستخدم نسخة من الكائن لتجنب مشاكل المراجع
    setIsEditSessionModalVisible(true);
  };

  const handleDeleteSession = async (sessionId, e) => {
    e.stopPropagation();

    Swal.fire({
      title: "تأكيد الحذف",
      text: "هل أنت متأكد من حذف هذه الجلسة؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "إلغاء",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await sessionsService.deleteSession(sessionId);
          Swal.fire({
            title: "تم الحذف!",
            text: "تم حذف الجلسة بنجاح",
            icon: "success",
            confirmButtonText: "حسناً",
          });
          fetchClientSessions(client.id);
        } catch (error) {
          Swal.fire({
            title: "خطأ!",
            text: "فشل في حذف الجلسة",
            icon: "error",
            confirmButtonText: "حسناً",
          });
          logger.error("خطأ في الحذف:", error);
        }
      }
    });
  };

  const handleViewSessionDetails = (sessionData, e) => {
    e.stopPropagation();
    setCurrentSessionDetails(sessionData);
    setViewSessionModalVisible(true);
  };

  const handleViewCaseDetails = (caseData, e) => {
    e.stopPropagation();
    navigate(`/cases/${caseData.id}`);
    onClose();
  };

  const handleEditCase = (caseData, e) => {
    e.stopPropagation();
    setCaseToEdit(caseData);
    setEditCaseModalVisible(true);
  };

  const handleDeleteCase = async (caseId, e) => {
    e.stopPropagation();

    Swal.fire({
      title: "تأكيد الحذف",
      text: "هل أنت متأكد من حذف هذه القضية؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "إلغاء",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await casesService.deleteCase(caseId);
          Swal.fire({
            title: "تم الحذف!",
            text: "تم حذف القضية بنجاح",
            icon: "success",
            confirmButtonText: "حسناً",
          });
          fetchClientCases(client.id);
        } catch (error) {
          Swal.fire({
            title: "خطأ!",
            text: "فشل في حذف القضية",
            icon: "error",
            confirmButtonText: "حسناً",
          });
          logger.error("خطأ في الحذف:", error);
        }
      }
    });
  };

  const handleEditPayment = (paymentData, e) => {
    e.stopPropagation();
    setPaymentToEdit(paymentData);
    setEditPaymentModalVisible(true);
  };

  const handleDeletePayment = async (paymentId, e) => {
    e.stopPropagation();

    Swal.fire({
      title: "تأكيد الحذف",
      text: "هل أنت متكد من حذف هذه الدفعة؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "إلغاء",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await paymentsService.deletePayment(paymentId);
          Swal.fire({
            title: "تم الحذف!",
            text: "تم حذف الدفعة بنجاح",
            icon: "success",
            confirmButtonText: "حسناً",
          });
          fetchClientPayments(client.id);
        } catch (error) {
          Swal.fire({
            title: "خطأ!",
            text: "فشل في حذف الدفعة",
            icon: "error",
            confirmButtonText: "حسناً",
          });
          logger.error("خطأ في الحذف:", error);
        }
      }
    });
  };

  // إضافة هذه الدالة لمعالجة النقر على زر عرض التفاصيل
  const handleViewPaymentDetails = (paymentData, e) => {
    e.stopPropagation();
    setCurrentPayment(paymentData);
    setViewPaymentDetails(true);
  };

  const handleAddSuccess = () => {
    fetchClientPayments(client.id);
  };

  const handleDeleteDocument = async (documentId, e) => {
    e.stopPropagation();

    Swal.fire({
      title: "تأكيد الحذف",
      text: "هل أنت متأكد من حذف هذا المستند؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "إلغاء",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await documentsService.deleteClientDocument(documentId);
          Swal.fire({
            title: "تم الحذف!",
            text: "تم حذف المستند بنجاح",
            icon: "success",
            confirmButtonText: "حسناً",
          });
          fetchClientDocuments(client.id);
        } catch (error) {
          Swal.fire({
            title: "خطأ!",
            text: "فشل في حذف المستند",
            icon: "error",
            confirmButtonText: "حسناً",
          });
          logger.error("خطأ في الحذف:", error);
        }
      }
    });
  };

  const reloadSessions = async () => {
    try {
      // استدعاء API لجلب بيانات الجلسات المحدثة
      const response = await sessionsService.getSessionsByClient(client.id);
      if (response && Array.isArray(response)) {
        setClientSessions(response);
      }
    } catch (error) {
      logger.error("خطأ في تحميل بيانات الجلسات:", error);
    }
  };

  // دالة معاينة الملف قبل الرفع
  const handleFilePreview = async (file) => {
    if (!file) return false;

    // التحقق من نوع الملف (مع دعم Excel)
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/zip",
      "application/x-rar-compressed",
      "application/x-zip-compressed",
    ];
    if (!allowedTypes.includes(file.type)) {
      message.error(
        "نوع الملف غير مدعوم. الرجاء رفع ملفات PDF, Word, Excel, صور, أو ملفات مضغوطة فقط"
      );
      return false;
    }

    // التحقق من حجم الملف (حد أقصى 10 ميجا)
    if (file.size > 10 * 1024 * 1024) {
      message.error("حجم الملف كبير جداً. الحد الأقصى 10 ميجابايت");
      return false;
    }

    // تحديد نوع المستند تلقائياً
    let documentType = "مستند عام";
    if (file.type.includes("pdf")) documentType = "ملف PDF";
    else if (file.type.includes("word")) documentType = "مستند Word";
    else if (file.type.includes("excel") || file.type.includes("sheet"))
      documentType = "جدول Excel";
    else if (file.type.includes("image")) documentType = "صورة";
    else if (file.type.includes("zip") || file.type.includes("rar"))
      documentType = "ملف مضغوط";

    // إعداد بيانات الملف
    setFileToUpload(file);
    setDocumentDetails({
      title: file.name.split(".")[0], // إزالة الامتداد من الاسم
      document_type: documentType,
      notes: "",
    });
    setShowFileDetailsModal(true);

    return false; // منع الرفع التلقائي
  };

  // دالة رفع الملف الفعلي
  const handleConfirmUpload = async () => {
    if (!fileToUpload) return;

    setUploading(true);
    try {
      // تمرير بيانات المستند مع الملف
      const response = await documentsService.uploadClientDocument(
        client.id,
        fileToUpload,
        documentDetails
      );

      message.success(`تم رفع "${documentDetails.title}" بنجاح!`);
      fetchClientDocuments(client.id);
      setShowUploadArea(false);
      setShowFileDetailsModal(false);
      setFileToUpload(null);
      setDocumentDetails({ title: "", document_type: "", notes: "" });
    } catch (error) {
      logger.error("Error uploading file:", error);
      message.error(
        "فشل في رفع الملف: " + (error.response?.data?.message || error.message)
      );
    } finally {
      setUploading(false);
    }
  };

  const casesColumns = [
    {
      title: "رقم القضية",
      dataIndex: "case_number",
      key: "case_number",
    },
    {
      title: "نوع القضية",
      dataIndex: "case_type",
      key: "case_type",
      render: (type) => <Tag color="blue">{type}</Tag>,
    },
    {
      title: "المحكمة",
      dataIndex: "court_name",
      key: "court_name",
    },
    {
      title: "الحالة",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "جارية" ? "green" : "orange"}>{status}</Tag>
      ),
    },
    {
      title: "تاريخ التسجيل",
      dataIndex: "filing_date",
      key: "filing_date",
      render: (date) => moment(date).format("YYYY/MM/DD"),
    },
    {
      title: "الإجراءات",
      key: "actions",

      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={(e) => handleViewCaseDetails(record, e)}
            className="text-green-500 hover:text-green-700"
          />
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={(e) => handleEditCase(record, e)}
            className="text-blue-500 hover:text-blue-700"
          />
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={(e) => handleDeleteCase(record.id, e)}
            className="text-red-500 hover:text-red-700"
          />
        </Space>
      ),
    },
  ];

  const sessionsColumns = [
    {
      title: "رقم القضية",
      dataIndex: ["case", "case_number"],
      key: "case_number",
      render: (text, record) => record.case_number || "-",
    },
    {
      title: "تاريخ الجلسة",
      dataIndex: "session_date",
      key: "session_date",
      render: (date) => moment(date).format("yyyy/MM/DD"),
    },
    {
      title: "وقت الجلسة",
      dataIndex: "session_time",
      key: "session_time",
      render: (time, record) => {
        // محاولة استخدام session_time أو time حسب المتوفر
        const sessionTime = time || record.time;
        if (!sessionTime) return "-";

        // تنسيق الوقت بشكل صحيح
        try {
          return moment(sessionTime, "HH:mm:ss").format("hh:mm A");
        } catch (error) {
          logger.error("Error formatting time:", error);
          return sessionTime; // إرجاع النص الأصلي إذا فشل التنسيق
        }
      },
    },
    {
      title: "نوع الجلسة",
      dataIndex: "session_type",
      key: "session_type",
      render: (type) => <Tag color="purple">{type}</Tag>,
    },
    {
      title: "حالة الجلسة",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "default";
        if (status === "منعقدة") color = "green";
        else if (status === "مؤجلة") color = "orange";
        else if (status === "ملغية") color = "red";
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: "القرارات",
      dataIndex: "decisions",
      key: "decisions",
      ellipsis: true,
    },

    {
      title: "ملاحظات",
      dataIndex: "notes",
      key: "notes",
      ellipsis: true,
    },
    {
      title: "الإجراءات",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={(e) => handleViewSessionDetails(record, e)}
            className="text-green-500 hover:text-green-700"
          />
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={(e) => handleEditSession(record, e)}
            className="text-blue-500 hover:text-blue-700"
          />
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={(e) => handleDeleteSession(record.id, e)}
            className="text-red-500 hover:text-red-700"
          />
        </Space>
      ),
    },
  ];

  // دالة لإظهار صورة مصغرة للملف
  const renderFileThumbnail = (record) => {
    const isImage =
      record.document_type?.toLowerCase().includes("صورة") ||
      record.original_name?.match(/\.(jpg|jpeg|png|gif)$/i);

    if (isImage) {
      const baseURL = process.env.REACT_APP_API_URL || "http://localhost:5000";
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      return (
        <img
          src={`${baseURL}/documents/${record.id}/preview?token=${token}`}
          alt={record.title}
          className="w-10 h-10 object-cover rounded border"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
      );
    }

    // أيقونة حسب نوع الملف
    let icon = <FileOutlined className="text-2xl text-gray-500" />;
    if (
      record.document_type?.includes("PDF") ||
      record.original_name?.includes(".pdf")
    ) {
      icon = <FileOutlined className="text-2xl text-red-500" />;
    } else if (
      record.document_type?.includes("Word") ||
      record.original_name?.match(/\.(doc|docx)$/i)
    ) {
      icon = <FileOutlined className="text-2xl text-blue-500" />;
    } else if (
      record.document_type?.includes("Excel") ||
      record.original_name?.match(/\.(xls|xlsx)$/i)
    ) {
      icon = <FileOutlined className="text-2xl text-green-500" />;
    }

    return (
      <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded border">
        {icon}
      </div>
    );
  };

  // دالة للمعاينة المحسنة
  const handleDocumentPreview = (record) => {
    try {
      const baseURL = process.env.REACT_APP_API_URL || "http://localhost:5000";
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const previewUrl = `${baseURL}/documents/${record.id}/preview?token=${token}`;
      window.open(previewUrl, "_blank");
    } catch (error) {
      message.error("فشل في معاينة المستند");
    }
  };

  // دالة للتحميل المحسنة
  const handleDocumentDownload = (record) => {
    try {
      const baseURL = process.env.REACT_APP_API_URL || "http://localhost:5000";
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      // استخدام baseURL الصحيح الذي يحتوي بالفعل على /api
      const downloadUrl = `${baseURL}/documents/${record.id}/download?token=${token}`;

      // إنشاء رابط مؤقت للتحميل
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = record.original_name || record.title;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      message.success("تم بدء التحميل");
    } catch (error) {
      message.error("فشل في تحميل المستند");
    }
  };

  const documentsColumns = [
    {
      title: "",
      key: "thumbnail",
      width: 60,
      render: (_, record) => renderFileThumbnail(record),
    },
    {
      title: "اسم المستند",
      key: "document_info",
      render: (_, record) => (
        <div className="text-right">
          <div className="font-medium text-gray-800 mb-1">
            {record.title || record.original_name}
          </div>
          <div className="text-xs text-gray-500">
            {record.original_name && record.title !== record.original_name && (
              <div>الاسم الأصلي: {record.original_name}</div>
            )}
            {record.file_size && (
              <div>
                الحجم: {(record.file_size / 1024 / 1024).toFixed(2)} ميجابايت
              </div>
            )}
          </div>
        </div>
      ),
    },
    {
      title: "النوع والتصنيف",
      key: "type_category",
      render: (_, record) => (
        <div className="text-right">
          <Tag color="blue" className="mb-1">
            {record.document_type || "مستند عام"}
          </Tag>
          {record.case_number && (
            <div className="text-xs text-green-600 font-medium">
              القضية: {record.case_number}
            </div>
          )}
          {record.case_type && (
            <div className="text-xs text-gray-500">{record.case_type}</div>
          )}
        </div>
      ),
    },
    {
      title: "تاريخ الإضافة",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      render: (date) => (
        <div className="text-right text-sm">
          <div>{moment(date).format("YYYY/MM/DD")}</div>
          <div className="text-xs text-gray-500">
            {moment(date).format("HH:mm")}
          </div>
        </div>
      ),
    },
    {
      title: "رفع بواسطة",
      dataIndex: "uploader_name",
      key: "uploader_name",
      width: 100,
      render: (name) => (
        <div className="text-right text-sm text-gray-600">
          {name || "غير معروف"}
        </div>
      ),
    },
    {
      title: "ملاحظات",
      dataIndex: "notes",
      key: "notes",
      ellipsis: true,
      render: (notes) => (
        <div className="text-right text-sm" title={notes}>
          {notes || "-"}
        </div>
      ),
    },
    {
      title: "الإجراءات",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <Space className="flex justify-end">
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={() => handleDocumentPreview(record)}
            className="text-blue-500 hover:text-blue-700"
            size="small"
            title="معاينة المستند"
          />
          <Button
            type="text"
            icon={<DownloadOutlined />}
            onClick={() => handleDocumentDownload(record)}
            className="text-green-500 hover:text-green-700"
            size="small"
            title="تحميل المستند"
          />
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={(e) => handleDeleteDocument(record.id, e)}
            className="text-red-500 hover:text-red-700"
            size="small"
            title="حذف المستند"
          />
        </Space>
      ),
    },
  ];

  const paymentsColumns = [
    {
      title: "التاريخ",
      dataIndex: "payment_date",
      key: "payment_date",
      render: (date) => moment(date).format("YYYY/MM/DD"),
    },
    {
      title: "المبلغ",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => (
        <span className="font-semibold">
          {parseFloat(amount).toLocaleString("ar-IQ")} د.ع
        </span>
      ),
    },
    {
      title: "نوع الدفعة",
      dataIndex: "payment_type",
      key: "payment_type",
      render: (type) => (
        <Tag color={type === "دفعة مقدمة" ? "green" : "blue"}>{type}</Tag>
      ),
    },
    {
      title: "طريقة الدفع",
      dataIndex: "payment_method",
      key: "payment_method",
      render: (method) => (
        <Tag color={method === "نقدي" ? "gold" : "purple"}>{method}</Tag>
      ),
    },
    {
      title: "الحالة",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Badge
          status={status === "مدفوع" ? "success" : "warning"}
          text={status}
        />
      ),
    },
    {
      title: "ملاحظات",
      dataIndex: "notes",
      key: "notes",
      ellipsis: true,
    },
    // في جزء تعريف paymentsColumns داخل ViewClientModal.js
    {
      title: "الإجراءات",
      key: "actions",
      render: (_, record) => {
        // تنسيق البيانات ليتوافق مع مكون PaymentReceipt
        const formattedPayment = {
          ...record,
          date: record.payment_date || record.date,
          type: record.payment_type || record.type || "other",
          client_name: client?.name || record.client_name,
        };

        return (
          <Space>
            {/* استخدام البيانات المنسقة */}
            <PaymentReceipt payment={formattedPayment} />

            {/* الأزرار الأخرى */}
            <Button
              type="text"
              icon={<EyeOutlined />}
              onClick={(e) => handleViewPaymentDetails(record, e)}
              className="text-blue-500 hover:text-blue-700"
              title="عرض التفاصيل"
            />

            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={(e) => handleEditPayment(record, e)}
              className="text-green-500 hover:text-green-700"
              title="تعديل"
            />

            <Button
              type="text"
              icon={<DeleteOutlined />}
              onClick={(e) => handleDeletePayment(record.id, e)}
              className="text-red-500 hover:text-red-700"
              title="حذف"
            />
          </Space>
        );
      },
    },
  ];

  // Add this function to calculate total payments
  const calculateTotalPayments = () => {
    if (!clientPayments || clientPayments.length === 0) return 0;

    return clientPayments.reduce((total, payment) => {
      // Ensure both values are treated as numbers
      const currentTotal = Number(total);
      // Convert payment amount to number and default to 0 if NaN
      const amount = Number(payment.amount) || 0;
      return currentTotal + amount;
    }, 0);
  };

  // Add these functions to calculate separate payment totals
  const calculateCompletedPayments = () => {
    if (!clientPayments || clientPayments.length === 0) return 0;

    return clientPayments
      .filter(
        (payment) =>
          payment.status === "completed" || payment.status === "مكتملة"
      )
      .reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0);
  };

  const calculatePendingPayments = () => {
    if (!clientPayments || clientPayments.length === 0) return 0;

    return clientPayments
      .filter(
        (payment) => payment.status === "pending" || payment.status === "معلقة"
      )
      .reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0);
  };

  return (
    <Modal
      title={
        <div
          dir="rtl"
          className="flex items-center text-lg md:text-xl font-bold text-gray-800"
        >
          <UserOutlined className="ml-2 text-primary" />
          {client?.name}
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width="95%"
      style={{ maxWidth: "1000px" }}
      className="custom-modal responsive-modal"
      styles={{ body: { padding: "10px", overflowX: "hidden" } }}
    >
      <Spin spinning={loading} dir="rtl">
        <Tabs
          defaultActiveKey="1"
          className="custom-tabs"
          onChange={handleTabChange}
          size={window.innerWidth < 768 ? "small" : "default"}
        >
          {/* معلومات العميل الأساسية */}
          <TabPane
            tab={
              <span className="flex items-center">
                <UserOutlined className="ml-1 md:ml-2" />
                <span className="text-xs md:text-sm">المعلومات</span>
              </span>
            }
            key="1"
          >
            <div className="overflow-x-auto">
              <Descriptions
                bordered
                column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                className="bg-white rounded-lg"
                size="small"
              >
                <Descriptions.Item label="اسم العميل" span={2}>
                  {client?.name}
                </Descriptions.Item>
                <Descriptions.Item label="رقم الهوية">
                  {client?.national_id}
                </Descriptions.Item>
                <Descriptions.Item label="نوع العميل">
                  <Tag
                    color={client?.client_type === "مدعي" ? "green" : "orange"}
                  >
                    {client?.client_type}
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="رقم الجوال">
                  {client?.phone ? (
                    <a
                      href={`https://wa.me/${
                        client.phone.replace(/[^0-9]/g, "").startsWith("964")
                          ? client.phone.replace(/[^0-9]/g, "")
                          : "964" + client.phone.replace(/[^0-9]/g, "")
                      }`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-green-600 hover:underline flex items-center gap-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-whatsapp"
                        viewBox="0 0 16 16"
                      >
                        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007-.133 0-.347.05-.529.248-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                      </svg>
                      {client.phone}
                    </a>
                  ) : (
                    "غير متوفر"
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="البريد الإلكتروني">
                  {client?.email || "غير متوفر"}
                </Descriptions.Item>
                <Descriptions.Item label="العنوان" span={2}>
                  {client?.address || "غير متوفر"}
                </Descriptions.Item>
                <Descriptions.Item label="رقم الوكالة">
                  {client?.power_of_attorney_number || "غير متوفر"}
                </Descriptions.Item>
                <Descriptions.Item label="تاريخ الوكالة">
                  {client?.power_of_attorney_date
                    ? moment(client.power_of_attorney_date).format("YYYY/MM/DD")
                    : "غير متوفر"}
                </Descriptions.Item>
                <Descriptions.Item label="سجل الوكالة">
                  {client?.power_of_attorney_record || "غير متوفر"}
                </Descriptions.Item>
                <Descriptions.Item label="كاتب العدل">
                  {client?.notary_name || "غير متوفر"}
                </Descriptions.Item>
                <Descriptions.Item label="عدد القضايا">
                  <Tag color="blue">{client?.cases_count}</Tag>
                </Descriptions.Item>
              </Descriptions>
            </div>

            <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2">
              <div className="flex flex-wrap gap-2 w-full md:w-auto">
                <Button
                  type="primary"
                  icon={<FileOutlined />}
                  onClick={handleAddCase}
                  size="middle"
                  className="w-full md:w-auto mb-2 md:mb-0"
                >
                  إضافة قضية
                </Button>

                <Button
                  type="primary"
                  icon={<CalendarOutlined />}
                  style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
                  size="middle"
                  onClick={handleAddSessionClick}
                  className="w-full md:w-auto mb-2 md:mb-0"
                >
                  إضافة جلسة
                </Button>

                <Button
                  type="primary"
                  icon={<DollarOutlined />}
                  style={{ backgroundColor: "#faad14", borderColor: "#faad14" }}
                  size="middle"
                  onClick={() => setShowAddPayment(true)}
                  className="w-full md:w-auto mb-2 md:mb-0"
                >
                  إضافة دفعة
                </Button>
              </div>

              <Button
                type="default"
                icon={<CloseOutlined />}
                onClick={onClose}
                size="middle"
                className="w-full md:w-auto"
              >
                إغلاق
              </Button>
            </div>
          </TabPane>

          {/* القضايا */}
          <TabPane
            tab={
              <span className="flex items-center">
                <FileOutlined className="ml-1 md:ml-2" />
                <span className="text-xs md:text-sm">القضايا</span>
                <Tag className="mr-1 md:mr-2" color="blue">
                  {clientCases.length}
                </Tag>
              </span>
            }
            key="2"
          >
            <div className="overflow-x-auto -mx-2 md:mx-0">
              <Table
                columns={casesColumns.map((column) => ({
                  ...column,
                  ellipsis: true,
                  render:
                    column.render ||
                    ((text) => (
                      <span className="text-xs md:text-sm">{text}</span>
                    )),
                }))}
                dataSource={clientCases}
                rowKey="id"
                pagination={false}
                className="bg-white rounded-lg mb-4"
                size="small"
                scroll={{ x: "max-content" }}
              />
            </div>

            <div className="mt-4 flex flex-col md:flex-row gap-2">
              <Button
                type="primary"
                icon={<FileOutlined />}
                onClick={handleAddCase}
                className="w-full md:w-auto mb-2 md:mb-0"
              >
                إضافة قضية جديدة
              </Button>
              <Button
                type="default"
                onClick={onClose}
                className="w-full md:w-auto"
              >
                إغلاق
              </Button>
            </div>
          </TabPane>

          {/* تبويب الجلسات */}
          <TabPane
            tab={
              <span className="flex items-center">
                <CalendarOutlined className="ml-1 md:ml-2" />
                <span className="text-xs md:text-sm">الجلسات</span>
                <Tag className="mr-1 md:mr-2" color="green">
                  {clientSessions.length}
                </Tag>
              </span>
            }
            key="3"
          >
            <div className="overflow-x-auto -mx-2 md:mx-0">
              <Table
                columns={sessionsColumns.map((column) => ({
                  ...column,
                  ellipsis: true,
                  render:
                    column.render ||
                    ((text) => (
                      <span className="text-xs md:text-sm">{text}</span>
                    )),
                  // إظهار فقط الأعمدة الضرورية على الهاتف
                  responsive: column.dataIndex === "notes" ? ["md"] : undefined,
                }))}
                dataSource={clientSessions}
                rowKey="id"
                pagination={false}
                loading={loading}
                locale={{ emptyText: "لا توجد جلسات لهذا العميل" }}
                className="bg-white rounded-lg mb-4"
                size="small"
                scroll={{ x: "max-content" }}
              />
            </div>

            <div className="mt-4 flex flex-col md:flex-row gap-2">
              <Button
                type="primary"
                icon={<CalendarOutlined />}
                style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
                onClick={handleAddSessionClick}
                className="w-full md:w-auto mb-2 md:mb-0"
              >
                إضافة جلسة جديدة
              </Button>
              <Button
                type="default"
                onClick={onClose}
                className="w-full md:w-auto"
              >
                إغلاق
              </Button>
            </div>
          </TabPane>

          {/* تبويب المدفوعات */}
          <Tabs.TabPane
            tab={
              <span className="flex items-center">
                <DollarOutlined className="ml-1 md:ml-2" />
                <span className="text-xs md:text-sm">المدفوعات</span>
                <Tag className="mr-1 md:mr-2" color="gold">
                  {clientPayments.length}
                </Tag>
              </span>
            }
            key="4"
          >
            <div className="bg-white rounded-lg p-2 md:p-4">
              <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4">
                {/* إحصائيات المدفوعات */}
                <Card
                  className="text-center shadow-md"
                  style={{
                    background:
                      "linear-gradient(135deg, #f6f8fe 0%, #e3ecff 100%)",
                  }}
                  bodyStyle={{ padding: "12px" }}
                  size="small"
                >
                  <Statistic
                    title={
                      <span className="text-gray-700 font-bold text-sm">
                        إجمالي المدفوعات
                      </span>
                    }
                    value={clientPayments.reduce(
                      (sum, payment) => sum + parseFloat(payment.amount || 0),
                      0
                    )}
                    precision={0}
                    valueStyle={{
                      color: "#1e40af",
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                    suffix="د.ع"
                    formatter={(value) => value.toLocaleString("ar-IQ")}
                  />
                </Card>

                <Card
                  className="text-center shadow-md"
                  style={{
                    background:
                      "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
                  }}
                  bodyStyle={{ padding: "12px" }}
                  size="small"
                >
                  <Statistic
                    title={
                      <span className="text-gray-700 font-bold text-sm">
                        المدفوعات المكتملة
                      </span>
                    }
                    value={calculateCompletedPayments()}
                    precision={0}
                    valueStyle={{
                      color: "#15803d",
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                    suffix="د.ع"
                    formatter={(value) => value.toLocaleString("ar-IQ")}
                  />
                </Card>

                <Card
                  className="text-center shadow-md"
                  style={{
                    background:
                      "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)",
                  }}
                  bodyStyle={{ padding: "12px" }}
                  size="small"
                >
                  <Statistic
                    title={
                      <span className="text-gray-700 font-bold text-sm">
                        المدفوعات المعلقة
                      </span>
                    }
                    value={calculatePendingPayments()}
                    precision={0}
                    valueStyle={{
                      color: "#c2410c",
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                    suffix="د.ع"
                    formatter={(value) => value.toLocaleString("ar-IQ")}
                  />
                </Card>
              </div>

              <div className="overflow-x-auto -mx-2 md:mx-0">
                <Table
                  columns={paymentsColumns.map((column) => ({
                    ...column,
                    ellipsis: true,
                    render:
                      column.render ||
                      ((text) => (
                        <span className="text-xs md:text-sm">{text}</span>
                      )),
                    // إخفاء بعض الأعمدة على الهاتف
                    responsive:
                      column.dataIndex === "notes" ? ["md"] : undefined,
                  }))}
                  dataSource={clientPayments}
                  rowKey="id"
                  pagination={false}
                  className="bg-white rounded-lg mb-4"
                  locale={{ emptyText: "لا توجد مدفوعات" }}
                  size="small"
                  scroll={{ x: "max-content" }}
                />
              </div>

              <div className="mt-4 flex flex-col md:flex-row gap-2">
                <Button
                  type="primary"
                  icon={<DollarOutlined />}
                  style={{ backgroundColor: "#faad14", borderColor: "#faad14" }}
                  onClick={() => setShowAddPayment(true)}
                  className="w-full md:w-auto mb-2 md:mb-0"
                >
                  إضافة دفعة جديدة
                </Button>
                <Button
                  type="default"
                  onClick={onClose}
                  className="w-full md:w-auto"
                >
                  إغلاق
                </Button>
              </div>
            </div>
          </Tabs.TabPane>

          {/* تبويب المستندات والمستمسكات */}
          <Tabs.TabPane
            tab={
              <span className="flex items-center">
                <FolderOpenOutlined className="ml-1 md:ml-2" />
                <span className="text-xs md:text-sm">المستندات</span>
                <Tag className="mr-1 md:mr-2" color="purple">
                  {clientDocuments.length}
                </Tag>
              </span>
            }
            key="5"
          >
            <div className="bg-white rounded-lg p-2 md:p-4">
              <div className="mb-6">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                      <FolderOpenOutlined className="text-blue-500" />
                      مستندات ومستمسكات العميل
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                      إجمالي المستندات:{" "}
                      <span className="font-medium text-blue-600">
                        {clientDocuments.length}
                      </span>
                    </p>
                  </div>

                  <div className="flex gap-2">
                    <Button
                      type="primary"
                      icon={<CloudUploadOutlined />}
                      onClick={() => setShowUploadArea(!showUploadArea)}
                      className="bg-gradient-to-r from-green-500 to-green-600 border-0 shadow-md hover:from-green-600 hover:to-green-700"
                    >
                      {showUploadArea ? "إخفاء الرفع" : "رفع مستند"}
                    </Button>
                    <Button
                      icon={<FolderOpenOutlined />}
                      onClick={() => fetchClientDocuments(client.id)}
                      className="bg-gray-50 border-gray-300 hover:bg-gray-100"
                    >
                      تحديث
                    </Button>
                  </div>
                </div>

                {/* منطقة رفع الملفات السهلة */}
                {showUploadArea && (
                  <div className="mb-4 p-4 bg-gradient-to-r from-blue-50 to-green-50 rounded-lg border border-blue-200">
                    <Upload.Dragger
                      name="file"
                      multiple={false}
                      beforeUpload={handleFilePreview}
                      showUploadList={false}
                      className="bg-white/70 border-2 border-dashed border-blue-300 hover:border-green-400 transition-all duration-300"
                      style={{ borderRadius: "12px" }}
                    >
                      <div className="py-6">
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined className="text-4xl text-blue-500" />
                        </p>
                        <p className="ant-upload-text text-gray-700 font-medium">
                          {uploading
                            ? "جاري رفع الملف..."
                            : "اسحب الملف هنا أو انقر للاختيار"}
                        </p>
                        <p className="ant-upload-hint text-gray-500 text-sm">
                          يمكنك رفع ملفات PDF، Word، Excel، صور، أو ملفات مضغوطة
                          (حد أقصى 10 ميجابايت)
                        </p>
                      </div>
                    </Upload.Dragger>

                    <div className="mt-3 flex justify-end">
                      <Button
                        size="small"
                        onClick={() => setShowUploadArea(false)}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        إلغاء
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              {/* استخدام مكون DocumentsList المحسن */}
              <DocumentsList
                documents={clientDocuments}
                onDelete={async (document) => {
                  await documentsService.deleteClientDocument(document.id);
                  fetchClientDocuments(client.id);
                }}
                onDownload={async (document) => {
                  try {
                    await documentsService.downloadClientDocument(
                      document.id,
                      document.original_name || document.title
                    );
                    message.success("تم بدء تحميل الملف");
                  } catch (error) {
                    console.error("Error downloading document:", error);
                    message.error("فشل في تحميل المستند");
                  }
                }}
                loading={loading}
                clientId={client?.id}
              />
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Spin>

      {/* Add Session Modal */}
      <AddSessionModal
        visible={showAddSessionModal}
        onClose={() => setShowAddSessionModal(false)}
        onSessionAdded={handleAddSuccess}
        clientId={client?.id}
        onSuccess={reloadSessions}
      />

      {/* Add Case Modal */}
      <AddCaseModal
        visible={showAddCaseModal}
        onClose={() => setShowAddCaseModal(false)}
        initialClientData={client}
        onSuccess={(newCase) => {
          fetchClientCases(client.id);
          setShowAddCaseModal(false);
          // Optional: message.success is already handled in AddCaseModal
        }}
      />

      {/* Edit Case Modal */}
      <EditCaseModal
        visible={editCaseModalVisible}
        onCancel={() => {
          setEditCaseModalVisible(false);
          setCaseToEdit(null);
        }}
        onSubmit={async (formData) => {
          try {
            await casesService.updateCase(caseToEdit.id, formData);
            message.success("تم تحديث القضية بنجاح");
            fetchClientCases(client.id);
            setEditCaseModalVisible(false);
            setCaseToEdit(null);
          } catch (error) {
            console.error("Error updating case:", error);
            message.error("حدث خطأ في تحديث القضية");
          }
        }}
        initialData={caseToEdit}
      />

      {/* Edit Session Modal */}
      <EditSessionModal
        visible={isEditSessionModalVisible}
        sessionData={currentSession}
        onCancel={() => setIsEditSessionModalVisible(false)}
        onSessionUpdated={handleAddSuccess}
        onSuccess={reloadSessions}
      />

      {/* View Session Modal */}
      <ViewSessionModel
        visible={viewSessionModalVisible}
        sessionData={currentSessionDetails}
        onClose={() => setViewSessionModalVisible(false)}
      />

      {/* Receipt Modal */}
      {/* <PaymentReceipt
        visible={showReceiptDialog}
        paymentData={selectedPayment}
        onClose={() => setShowReceiptDialog(false)}
        clientData={client}
      /> */}

      {/* Payment Details Modal */}
      {/* Payment Details Modal */}
      {viewPaymentDetails && (
        <PaymentDetailsModal
          payment={currentPayment}
          onClose={() => setViewPaymentDetails(false)}
        />
      )}

      {/* Add Payment Modal */}
      <AddPaymentModal
        visible={showAddPayment}
        onClose={() => setShowAddPayment(false)}
        onPaymentAdded={handleAddSuccess}
        clientId={client?.id}
      />

      {/* Edit Payment Modal */}
      <EditPaymentModal
        visible={editPaymentModalVisible}
        onClose={() => {
          setEditPaymentModalVisible(false);
          setPaymentToEdit(null);
        }}
        onSuccess={() => {
          fetchClientPayments(client.id);
          setEditPaymentModalVisible(false);
          setPaymentToEdit(null);
        }}
        payment={paymentToEdit}
      />

      {/* Edit Session Modal */}
      <EditSessionModal
        visible={isEditSessionModalVisible}
        sessionData={currentSession}
        onClose={() => {
          setIsEditSessionModalVisible(false);
          setCurrentSession(null);
        }}
        onSuccess={() => {
          fetchClientSessions(client.id);
          setIsEditSessionModalVisible(false);
          setCurrentSession(null);
        }}
      />

      {/* File Details Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2">
            <FileOutlined className="text-blue-500" />
            تفاصيل المستند
          </div>
        }
        visible={showFileDetailsModal}
        onOk={handleConfirmUpload}
        onCancel={() => {
          setShowFileDetailsModal(false);
          setFileToUpload(null);
          setDocumentDetails({ title: "", document_type: "", notes: "" });
        }}
        okText={uploading ? "جاري الرفع..." : "رفع المستند"}
        cancelText="إلغاء"
        confirmLoading={uploading}
        width={600}
        className="rtl-modal"
      >
        <div className="py-4">
          {fileToUpload && (
            <div className="mb-4 p-3 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-600">الملف المحدد:</p>
              <p className="font-medium text-gray-800">{fileToUpload.name}</p>
              <p className="text-xs text-gray-500">
                الحجم: {(fileToUpload.size / 1024 / 1024).toFixed(2)} ميجابايت
              </p>
            </div>
          )}

          <Form layout="vertical" className="space-y-4">
            <Form.Item label="عنوان المستند" required>
              <Input
                value={documentDetails.title}
                onChange={(e) =>
                  setDocumentDetails({
                    ...documentDetails,
                    title: e.target.value,
                  })
                }
                placeholder="أدخل عنوان وصفي للمستند"
                className="text-right"
              />
            </Form.Item>

            <Form.Item label="نوع المستند" required>
              <Select
                value={documentDetails.document_type}
                onChange={(value) =>
                  setDocumentDetails({
                    ...documentDetails,
                    document_type: value,
                  })
                }
                placeholder="اختر نوع المستند"
                className="text-right"
              >
                <Select.Option value="هوية شخصية">هوية شخصية</Select.Option>
                <Select.Option value="جواز سفر">جواز سفر</Select.Option>
                <Select.Option value="شهادة ميلاد">شهادة ميلاد</Select.Option>
                <Select.Option value="عقد">عقد</Select.Option>
                <Select.Option value="فاتورة">فاتورة</Select.Option>
                <Select.Option value="ملف PDF">ملف PDF</Select.Option>
                <Select.Option value="مستند Word">مستند Word</Select.Option>
                <Select.Option value="جدول Excel">جدول Excel</Select.Option>
                <Select.Option value="صورة">صورة</Select.Option>
                <Select.Option value="ملف مضغوط">ملف مضغوط</Select.Option>
                <Select.Option value="مستند قانوني">مستند قانوني</Select.Option>
                <Select.Option value="مراسلات">مراسلات</Select.Option>
                <Select.Option value="مستند عام">مستند عام</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item label="ملاحظات">
              <Input.TextArea
                value={documentDetails.notes}
                onChange={(e) =>
                  setDocumentDetails({
                    ...documentDetails,
                    notes: e.target.value,
                  })
                }
                placeholder="أضف أي ملاحظات إضافية حول المستند (اختياري)"
                rows={3}
                className="text-right"
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </Modal>
  );
};

export default ViewClientModal;
